<template>
  <div>
    <div v-if="isLoading"
      class="top-0 z-10 h-full max-h-screen fixed w-full custom-bg flex flex-col justify-center items-center">
      <div class="suspense flex justify-center items-center">
        <p class="text-black">Loading....</p>
      </div>
    </div>

    <div v-else class="relative">
      <div v-if="!saving || saving === ''" class="page">
        <header class="header">
          <div class="flex flex-col lg:flex-row justify-between items-center">
            <div class="header__desc w-full">
              <h1 class="text-black text-left">{{ titleCase(indicator)
                }}</h1>
              <div class="flex gap-2 items-center mb-4">
                <p class="text-gray-200 text-left p-question  w-full md:w-auto">
                  Original question: </p>
                <span class="font-bold block">{{ userQuestion }}</span>
              </div>
              <p>{{ dataset.source[selectedPeriod] }}</p>
              <div class="actions flex gap-6">
                <button class="flex justify-between items-center border action__btn" @click="showShareModal = true">
                  <span class="inline-block">Share</span> <img src="@/assets/svg/share-icon.svg"
                    alt="share icon" /></button>
                <!-- <button class="flex justify-between items-center border action__btn" @click="
                  checkAuthBefore(() => {
                    showEmbedModal = true;
                  })
                  ">
                  <span class="inline-block">Embed</span> <img src="@/assets/svg/embed-icon.svg" alt="embed icon" />
                </button> -->
                <button class="flex justify-between items-center border action__btn" @click="
                  //   checkAuthBefore(() => {
                  //     showDownloadModal = true;
                  //   });
                  generate();
                saveAsPng()
                  ">
                  <span class="inline-block">Download</span> <img src="@/assets/svg/download-icon.svg"
                    alt="download icon" />
                </button>
              </div>
              <div class="analysis">
                <h3>Analysis</h3>
                <p v-if="analysisLoading" class="data_analysis suspense text-center">Analysing data... Please wait</p>
                <p class="main__desc" v-else v-html="formattedAnalysis"></p>
                <p class="disclaimer" v-if="analysis_payload">
                  Please note: Analysis is generated by an algorithm. Users are advised to review
                  for context and accuracy
                </p>
              </div>
            </div>
            <form action="" class="search__wrapper" @submit.prevent="goToSearch()">
              <p>Search for something different</p>
              <div class="form__input flex border items-center gap-2">
                <img src="@/assets/svg/search.svg" alt="Search Icon" />
                <input type="search" placeholder="Ask a question" name="" id="" class="w-full h-full" v-model="search">
              </div>
              <button :disabled="formLoading" class="w-full flex items-center justify-center bg-brandCol rounded-lg">{{
                formLoading ? "Searching..." : "Search" }}</button>
            </form>
          </div>
          <!-- <h1>
            {{ titleCase(kebabCase(country)) }}: {{ titleCase(indicator)
            }}<span class="change-options">
              <div class="change-country" @click="
                showModal = true;
              isCountry = true;
              ">
                <p>
                  Change Country<span><img src="../../../assets/arrow-down.svg" alt="" /></span>
                </p>
              </div>
              <div class="change-indicator-wrapper">
                <div class="loading-spinner" v-if="isIndicatorLoading"></div>
                <div class="change-indicator" @click="
                  showModal = true;
                isIndicator = true;
                setCategory(0);
                ">
                  <p>
                    Change Indicator<span><img src="../../../assets/arrow-down.svg" alt="" /></span>
                  </p>
                </div>
              </div>
            </span>
          </h1> -->
          <div class="backdrop" v-if="showModal" @click="
            showModal = false;
          isCountry = false;
          isIndicator = false;
          "></div>
          <!-- country modal -->
          <div class="country-modal" v-if="isCountry">
            <input type="text" placeholder="Search Country" v-model="search" />
            <div class="countries" v-if="filteredCountries.length">
              <div v-for="country in filteredCountries" :key="country.name.common">
                <p @click="
                  selectedCountry = country.name.common;
                showModal = false;
                isCountry = false;
                isIndicator = false;
                ">
                  {{ country.name.common }}
                </p>
              </div>
            </div>
            <div class="countries" v-else>
              <p>No search result found</p>
            </div>
          </div>
          <!--  -->
          <!-- indicator modal -->
          <div class="indicator-modal" v-if="isIndicator">
            <div class="category-switch-btn" @click="isShowCategories = true">
              <div class="category-switch-btn-text">
                <p>Indicator Category</p>
                <h3>{{ allCategories[allCategoriesIndex] }}</h3>
              </div>
              <div class="category-switch-btn-arrow">
                <img src="../../../assets/arrow-down.svg" alt="" />
              </div>
            </div>

            <div class="indicators" v-if="categoryIndicators.length">
              <!-- indicators will be called here -->
              <div v-if="selectedCountry.length">
                <a v-for="indicator in categoryIndicators" :key="indicator.id"
                  :href="`/advanced/${indicator.name}/${selectedCountry.toLowerCase()}`">{{ indicator.name }}</a>
              </div>
              <div v-else>
                <a v-for="indicator in categoryIndicators" :key="indicator.id"
                  :href="`/advanced/${indicator.name}/${country}`">{{ indicator.name }}</a>
              </div>
            </div>
            <div class="indicators" v-else>
              <!-- if there are no indicators for a category -->
              <p>No Indicators for this category</p>
            </div>
            <!-- category modal -->
            <div class="category-modal" v-if="isShowCategories" @click="isShowCategories = false">
              <div class="categories">
                <div v-for="(category, index) in allCategories" :key="category" @click="
                  allCategoriesIndex = index;
                setCategory(index);
                ">
                  <p>{{ category }}</p>
                </div>
              </div>
            </div>
            <!--  -->
            <!--  -->
          </div>

        </header>
        <div class="main w-full">
          <div class="chart__cover">
            <div v-if="!notFound" class="controls">
              <div class="options">
                <template v-if="isLoading">
                  <div class="suspense"></div>
                  <div class="suspense"></div>
                  <div class="suspense"></div>
                  <div class="suspense"></div>
                  <div class="suspense"></div>
                  <div class="suspense"></div>
                </template>
                <template>
                  <!-- class="options--inputs" -->
                  <!-- <k-input v-model="chatToggleDefault.chartType" :optionsDisplay="['line', 'bar']" label="Chart Type"
                    type="select" />
                  <k-input v-model="frequency" :optionsDisplay="defaultPeriod" label="Frequency" type="select" /> -->
                  <!-- <k-input v-model="dataset.startYear" :optionsDisplay="yearsLessThan" label="Start Year"
                    searchInside="start year" type="select" /> -->
                  <!-- <k-input v-model="dataset.endYear" :optionsDisplay="yearsGreaterThan" label="End Year"
                    searchInside="end year" type="select" /> -->
                  <div class="chart-type-dropdown flex gap-4" v-if="!isLoading">
                    <select v-model="chartToggleDefault.chartType" class="custom-select">
                      <option value="line">Line Chart</option>
                      <option value="bar">Bar Chart</option>
                    </select>
                    <select v-model="chartToggleDefault.color" class="custom-select">
                      <option v-for="item in chartColor" :key="item.color" :value="item.color">{{ item.name }}</option>
                    </select>
                    <select v-model="chartToggleDefault.startYear" class="custom-select">
                      <option v-for="year in startYearOptions" :key="year" :value="year">{{ year }}</option>
                    </select>
                    <select v-model="chartToggleDefault.endYear" class="custom-select">
                      <option v-for="year in endYearOptions" :key="year" :value="year">{{ year }}</option>
                    </select>
                  </div>
                </template>

              </div>
              <!-- <k-button class="compare-btn" @click="$router.push(`/compare?${compareDataQuery}`)">
                Compare Data
              </k-button> -->

              <div class="hidden lg:flex items-center compare__toggle">
                <div v-for="option in defaultPeriod" :key="option"
                  :class="['inline-block btn__main cursor-pointer', { 'btn__active': option === selectedPeriod }]"
                  role="button" aria-label="toggle button" @click="updateFrequency(option)">
                  {{ option }}</div>
              </div>
            </div>

            <div @mousemove="follow" @mouseover="follow"
              :class="['chart flex items-center gap-0', { suspense: isLoading }]">
              <!-- <div class="metric">{{ dataset.metric }} {{ dataset.currency }}</div> -->
              <template v-if="!isLoading">
                <div class="chart__wrapper w-full">
                  <!-- <bar-chart-wrapper v-if="dataset.chartType === 'bar' && show" :datasets="chartData.datasets"
                    :labels="chartData.labels" :height="150" />
                  <line-wrapper v-if="dataset.chartType === 'line' && show" :datasets="chartData.datasets" :height="150"
                    :labels="chartData.labels" /> -->

                  <BarChartComponent v-if="chartToggleDefault.chartType === 'bar'" id="test-chart"
                    :options="chartOptions" :chartData="chartData" :key="'bar-' + selectedPeriod" />
                  <LineChartComponent v-if="chartToggleDefault.chartType === 'line'" id="test-chart"
                    :options="chartOptions" :chartData="chartData" :key="'line-' + selectedPeriod" />

                </div>
              </template>
              <div ref="definition" :style="{
                visibility: isLoading || !dataset.indicatorDefinition ? 'hidden' : 'visible',
              }" class="hover-helper">
                <!--            <div class='name'>{{ titleCase(dataset.indicator) }}</div>-->
                <template v-if="dataset.data && dataset.data.length">
                  <div :class="['definition', { shown: dataset.indicatorDefinition }]">
                    {{ dataset.indicatorDefinition }}
                  </div>
                </template>
              </div>
            </div>
          </div>
          <div class="more-info justify-between">
            <div class="notes">
              <div class="notes__content">
                <!-- <template v-if="isAuthenticated">
                  <h5 class="text-gray-200 font-bold mt-6">Source</h5>
                  <a v-if="fullQueryResult?.dataset?.metadata?.link" :href="fullQueryResult?.dataset?.metadata?.link">
                    {{ `${fullQueryResult?.dataset?.metadata?.source} | ${fullQueryResult?.dataset?.metadata?.link}` }}
                  </a>
                  <h5 class="text-gray-200 font-bold mt-3">Notes</h5>
                  <p class="notes-text">{{ analysis_payload[selectedPeriod].limitations }}</p>
                </template>
                <template v-else>
                  <h3>Notes</h3>
                  <p v-if="!dataset.notes">No notes available</p>
                  <ul v-else>
                    <li v-for="note in dataset.notes.split(/\*\s{0,2},/g)" :key="note">
                      {{ note }}{{ !note.endsWith('*') ? '*' : '' }}
                    </li>
                  </ul>
                </template> -->
                <template>
                  <h5 class="text-gray-200 font-bold mt-6">Source</h5>
                  <p v-if="fullQueryResult?.dataset?.metadata?.link[selectedPeriod]">
                    {{ `${fullQueryResult?.dataset?.metadata?.source[selectedPeriod]} ` }}
                  </p>
                  <h5 class="text-gray-200 font-bold mt-3">Notes</h5>
                  <p class="notes-text">{{ analysis_payload[selectedPeriod].limitations }}</p>
                  <p class="notes-text">Can't find what you're looking for? Email us on <span
                      class="underline font-medium">oafolabi@kwerty.io</span></p>
                </template>
              </div>
            </div>
            <div class="meta">
              <div class="meta__content meta__mod">
                <h5 class="mb-1">Related Data</h5>
                <button v-for="(item, idx) in fullQueryResult?.related_search" :key="idx" class="underline mb-1 block"
                  @click="goToSearch(item.search)">{{ item.search }}</button>
              </div>
            </div>
          </div>
        </div>


        <div v-if="customize || readyCompare" class="overlay" @click="customize = false"></div>
        <transition name="slide-up">
          <div v-if="customize" class="customize-options">
            <h1>Customize Chart</h1>

            <div class="controls">
              <k-input v-model="mobileOptions.chartType" :optionsDisplay="chartTypeOptions" label="Chart Type"
                type="select" />
              <k-input v-model="mobileOptions.colour" :optionsDisplay="colourOptions" label="Colour" type="select" />
              <k-input v-model="mobileOptions.frequency" :optionsDisplay="frequencyOptions" label="Frequency"
                type="select" />
              <k-input v-model="mobileOptions.startYear" :optionsDisplay="yearsLessThan" label="Start Year"
                searchInside="start year" type="select" />
              <k-input v-model="mobileOptions.endYear" :optionsDisplay="yearsGreaterThan" label="End Year"
                searchInside="end year" type="select" />
            </div>

            <div class="mobile-view-controls no-shadow">
              <k-button mobile variant="tertiary" @click="customize = false">Cancel</k-button>
              <k-button mobile @click="updateDataset()"> Finish </k-button>
            </div>
          </div>
        </transition>

        <transition name="slide-up">
          <div v-if="readyCompare" class="customize-options">
            <h1>Compare Data with</h1>

            <div class="controls">
              <k-input v-model="country2" :optionsDisplay="countries" label="Country" searchInside="countries"
                type="select" />
              <k-input v-model="category2" :optionsDisplay="categories" label="Category" searchInside="categories"
                type="select" @search="(val) => fetchIndicators({ name: val })" />
              <k-input v-model="dataset2.indicator" :optionsDisplay="indicators2" label="Indicator"
                searchInside="indicators" type="select" @search="(val) => fetchIndicators({ name: val })" />
              <k-input v-model="dataset2.startYear" :optionsDisplay="yearsLessThan" label="Start Year"
                searchInside="start year" type="select" />
              <k-input v-model="dataset2.endYear" :optionsDisplay="yearsGreaterThan" label="End Year"
                searchInside="end year" type="select" />
            </div>

            <div class="mobile-view-controls no-shadow">
              <k-button mobile variant="tertiary" @click="readyCompare = false">Cancel</k-button>
              <k-button mobile @click="$router.push(`/compare?${compareDataQuery}`)">
                Submit
              </k-button>
            </div>
          </div>
        </transition>

        <!-- Share MODAL -->
        <k-modal :open="showShareModal" middle @close="showShareModal = false">
          <k-card heading="Share with others" padInside smaller variant="in-modal" wrapHeading>
            <p class="modal-paragraph share">
              Anyone with the link can immediately view the page on their web browser.
            </p>
            <k-input :value="shareLink" disabled label="" variant="copyInput"></k-input>
            <div class="btn-container">
              <a :href="`https://twitter.com/share?ref_src=twsrc%5Etfw&url=${encodeURIComponent(
                shareLink
              )}`" rel="noreferrer" target="_blank">
                <k-button variant="tertiary">Twitter</k-button>
              </a>
              <a :href="`https://wa.me?text=${encodeURIComponent(shareLink)}`" rel="noreferrer" target="_blank">
                <k-button variant="tertiary">Whatsapp</k-button>
              </a>
              <a :href="`mailto:?body=${encodeURIComponent(shareLink)}`" rel="noreferrer" target="_blank">
                <k-button variant="tertiary">Email</k-button>
              </a>
            </div>
            <div class="cta">
              <k-button variant="secondary" @click="showShareModal = false">Close</k-button>
            </div>
          </k-card>
        </k-modal>

        <!-- Embed MODAL -->
        <k-modal :open="showEmbedModal" middle @close="showEmbedModal = false">
          <k-card heading="Embed HTML" padInside smaller variant="in-modal" wrapHeading>
            <p class="modal-paragraph">
              Copy and paste the code below to embed this chart on any page.
            </p>
            <k-input :value="embedString" disabled label="" variant="copyInput"> </k-input>
            <div class="btn-container embed">
              <k-input v-model="embedWidth" label="Width"></k-input>
              <k-input v-model="embedHeight" label="Height"></k-input>
            </div>

            <div class="cta">
              <k-button variant="secondary" @click="showEmbedModal = false">Close</k-button>
            </div>
          </k-card>
        </k-modal>

        <!-- Download MODAL -->
        <k-modal :open="showDownloadModal" middle @close="showDownloadModal = false">
          <k-card heading="Save to Your Device" padInside smaller variant="in-modal">
            <p class="modal-paragraph">Save a copy of this data to your device in PDF, CSV or PNG.</p>
            <div class="btn-container download">
              <!-- <k-button :loading="isSavingCsv" variant="tertiary" @click="saveAsCsv">as CSV</k-button>
              <k-button variant="tertiary" @click="saveAsPdf()">as PDF</k-button> -->
              <k-button variant="tertiary" @click="saveAsPng()">as PNG</k-button>
            </div>
            <div class="cta">
              <k-button variant="secondary" @click="showDownloadModal = false">Close</k-button>
            </div>
          </k-card>
        </k-modal>

        <!-- Not Found MODAL -->
        <k-modal :open="notFound" middle @close="notFound = false">
          <k-card heading="" padInside smaller variant="in-modal">
            <div class="img-container">
              <img alt="" src="@/assets/attention.svg" />
            </div>
            <h1 class="modal__heading">Sorry! There’s no dataset available for your selection.</h1>
            <k-button size="full" @click="
              $router.go(-1);
            show = false;
            ">Go Back
            </k-button>
          </k-card>
        </k-modal>
      </div>
      <template v-else-if="saving === 'png'">
        <save-as-png
          :options="{ ...dataset, indicator, country, source: fullQueryResult?.dataset?.metadata?.source[selectedPeriod] }"
          @back="cancelSaving"></save-as-png>
      </template>
      <template v-else-if="saving === 'pdf'">
        <save-as-pdf
          :options="{ ...dataset, indicator, country, analysis, source: fullQueryResult?.dataset?.metadata?.source[selectedPeriod] }"
          @back="cancelSaving">
        </save-as-pdf>
      </template>
      <Footer />
      <div v-if="formLoading || isLoading"
        class="top-0 z-10 h-full max-h-screen fixed w-full custom-bg flex flex-col justify-center items-center">
        <div class="suspense flex justify-center items-center">
          <p class="text-black">Loading....</p>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import SingleResult from './SingleResult';

export default SingleResult;
</script>

<style lang="scss" scoped src="./SingleResult.scss"></style>
